module.exports = __webpack_public_path__ + "static/media/SpiritedFearfulBactrian-size_restricted.94ddecbe.gif";